module.exports = __webpack_public_path__ + "static/img/11areaA_04.f5d3c61.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_04.png
// module id = 998
// module chunks = 1